export enum GDPRStatusEnum {
  GDPR_EMAIL_SENT = 'GDPR_EMAIL_SENT',
  GDPR_LINK_CLICKED = 'GDPR_LINK_CLICKED',
  GDPR_COMPLETED = 'GDPR_COMPLETED'
}
